import { Flex, Input, TableColumnsType } from "antd";
import usePatientTable, { PatientTableProps } from "./usePatientTable";
import Button from "../../atoms/Button/Button";
import Table, { Column } from "../../atoms/Table/Table";

const PatientSummaryTable = (props: PatientTableProps) => {
  const { isLoading, onActionClick, handleDateChange, formattedDate } =
    usePatientTable(props);
  const { dataSource, patientData, isVivitraEnabled, isLoading: tableDataIsLoading } = props;
  // console.log("dataSource", dataSource, patientData, isVivitraEnabled);

  const columns: Column[] = [
    {
      label: "Cycle Number",
      accessor: "visit_cycle",
      //key: "visit_cycle"
    },
    {
      label: "Status",
      accessor: "visit_status",
      //key: "visit_status",
      render: (val, record, rowIndex) => (
        <>
          <p className="mt-0 mb-1">
            {val === "VA" ? "Completed" : "Upcoming"}
          </p>
          {record?.visit_status !== "VA" ? (
            <div>
              <Input
                name="cycle_date"
                value={formattedDate(record)}
                type="date"
                onChange={(e) => handleDateChange(e, record)}
                disabled={isLoading}
              />
            </div>
          ) : (
            <div>
              <Input
                name="cycle_date"
                value={formattedDate(record)}
                type="date"
                readOnly
                disabled={isLoading}
              />
            </div>
          )}
        </>
      ),
    },
    {
      //key: "therapy_type",
      label: "Therapy Type",
      accessor: "visit_meta_info",
      render: (val, record, rowIndex) => (
        <span className="capitalize">{val?.target_therapy_drug || "--"}</span>
      ),
    },
    {
      //key: "therapy_drug",
      label: "Therapy Drug",
      accessor: "visit_meta_info",
      render: (val, record, rowIndex) => val?.therapy_type || "--",
    },
    {
      //key: "therapy_indication",
      label: "Therapy Indication",
      accessor: "visit_meta_info",
      render: (val, record, rowIndex) => val?.therapy_indication || "--",
    },
    {
      //key: "rewards",
      label: "Rewards",
      accessor: "visit_meta_info",
      render: (val, record, rowIndex) => {
        let statusClass, displayText;
      
        if (val?.rewards_assigned) {
          statusClass = "assigned";
          displayText = "Assigned";
        } else {
          if (record?.visit_status === "VA") { // for completed cycles
            statusClass = "not-assigned";
            displayText = "Not Assigned";
          } else { // pending/upcoming cycle
            statusClass = "pending";
            displayText = "Pending";
          }
        }
      
        return (
          <span className={`capitalize font-bold ${statusClass}`}>
            {displayText}
          </span>
        );
      },
    },
    {
      //key: "notes",
      label: "Notes",
      accessor: "visit_meta_info",
      render: (val, record, rowIndex) => val?.notes || "--",
    },
    {
      //key: "action",
      label: "ACTION",
      accessor: "action",
      render: (val, record, rowIndex) => {
        return (
          <Button
          variant="outlined"
          onClick={() => onActionClick(record)}
          disabled={isLoading}
        >
          View Details
        </Button>
        )
      },
    },
  ];

  return (
    <Flex gap="middle" vertical className="mt-16">
      <Table
        columns={columns}
        //dataSource={dataSource}
        data={dataSource}
        //rowKey="patient_visit_id"
        //pagination={false}
        isLoading={tableDataIsLoading}
      />
    </Flex>
  );
};

export default PatientSummaryTable;
